import { createSlice } from "@reduxjs/toolkit";
import { app_reset } from "../App/reducer";

import { DEFAULT_CONTENT } from "../../actions/Detail/constants";
import { createContent } from "../../utils/dataTransform/ContentItem/content";
import {
    createLeadVideoOrAudio,
    createLeadImage,
    createLeadPhotogallery,
    createLeadSegmentOrEpisodeAudio,
} from "../../utils/dataTransform/ContentItem/media";

/*
 * Initializes the Detail state
 * content and author are initialized with default Objects
 * lead media fields are initialized as null
 *
 * @returns {object} The initialized Detail state
 */
export const initDetailState = () => {
    return {
        content: DEFAULT_CONTENT,
        leadVideoOrAudio: null,
        leadImage: null,
        leadPhotogallery: null,
        leadSegmentOrEpisodeAudio: null,
    };
};

const detailSlice = createSlice({
    name: "detail",
    initialState: initDetailState(),
    reducers: {
        reset_detail: () => {
            return initDetailState();
        },

        receive_detail: {
            reducer: (state, action) => {
                return {
                    ...state,
                    ...action.payload,
                };
            },
            prepare: (json) => {
                return {
                    payload: {
                        content: createContent(json),
                        leadVideoOrAudio: createLeadVideoOrAudio(json),
                        leadImage: createLeadImage(json),
                        leadPhotogallery: createLeadPhotogallery(json),
                        leadSegmentOrEpisodeAudio:
                            createLeadSegmentOrEpisodeAudio(json),
                    },
                };
            },
        },

        update_related_items: {
            reducer: (state, action) => {
                return {
                    ...state,
                    content: {
                        ...state.content,
                        ...action.payload,
                    },
                };
            },
            prepare: (json) => {
                return {
                    payload: {
                        relatedItems: json,
                    },
                };
            },
        },
    },

    extraReducers: (builder) => {
        builder.addCase(app_reset, () => {
            return initDetailState();
        });
    },
});

export const { reset_detail, receive_detail, update_related_items } =
    detailSlice.actions;

export default detailSlice.reducer;
